<template lang="pug">
  b-tooltip.task-label(v-if="label" :position="tooltipPosition" :label="label.name" :active="iconOnly" :type="label.color")
    b-icon(v-if="iconOnly" :icon="label.icon" :type="label.color")
    component(:is="button ? 'b-button' : 'b-tag'" v-else :type="label.color" v-bind="$attrs" :class="{'is-rounded': isRounded}")
      b-icon(v-if="label.icon" :icon="label.icon")
      span {{ label.name }}
</template>

<script>
import BTooltip from 'buefy/src/components/tooltip/Tooltip';
export default {
  name: 'ui-label',
  components: { BTooltip },
  props: {
    label: Object,
    iconOnly: Boolean,
    button: Boolean,
    isRounded: {
      type: Boolean,
      default: () => false,
    },
    tooltipPosition: {
      type: String,
      default: () => 'is-top',
    },
  },
};
</script>
